// extracted by mini-css-extract-plugin
export default {"TeaserCard__modalContent":"TeaserCard__modalContent_ypDi_","TeaserCard__ctaGroup":"TeaserCard__ctaGroup_DZnJ4"};